import styled from 'styled-components';
import { Box, Button as MuiButton } from '@material-ui/core';

import Button from '../../../components/Button';
import Modal from '../../../components/Modal';

import theme from '../../../styles/defaultTheme';

export const CustomContainer = styled(Box)`
  gap: 8px;
  flex-wrap: wrap;

  & > div {
    flex: 2;

    &:first-child {
      flex: 1;
    }
  }

  @media screen and (max-width: 1260px) {
    & > * {
      width: 49%;
      flex: none !important;
    }

    button {
      margin-top: 8px !important;
    }
  }

  @media screen and (max-width: 840px) {
    & > * {
      width: 100%;
    }
  }
`;

export const CustomButton = styled(MuiButton)`
  margin-bottom: 8px !important;
  padding-right: 0 !important;

  .MuiButton-label {
    font-size: ${theme.font.size16};
    font-weight: bold;
    text-transform: initial;
    line-height: 14px;
    color: ${(props) => props.theme.orange};

    .MuiButton-text {
      text-decoration: underline;
    }
  }
`;

export const CustomModal = styled(Modal)`
  .ant-modal-body {
    max-height: 476px;
    overflow: auto;
  
    font-size: ${theme.font.size16};
    line-height: 24px;
    color: ${(props) => props.theme.greyLink};

    & > div {
      display: block;

      .type-operation-container {
        padding: 16px;
        background-color: ${(props) => props.theme.lightGrey};

        strong {
          margin-bottom: 8px;

          font-size: ${theme.font.size16};
          line-height: 20px;
          color: ${(props) => props.theme.black};
        }
      }

      .action {
        margin-top: 24px;

        b {
          margin-bottom: 8px;

          font-size: ${theme.font.size14};
          text-transform: uppercase;
          line-height: 17px;
          color: ${(props) => props.theme.black};
        }
      }

      p {
        margin: 0;

        font-size: ${theme.font.size14};
        line-height: 21px;
        color: ${(props) => props.theme.grey};
      }
    }
  }
`;

export const TableMessage = styled.span`
  font-weight: bold;
  font-size: ${theme.font.size18};
  width: 100%;
  margin-bottom: 6px;
`;

export const SearchButton = styled(Button)`
  height: 44px;
  margin-top: 32px;
`;
